import { DownloadAppPlaceholder } from "@components/DownloadAppPlaceholder";
import { MainLayout, MainLayoutProps } from "@components/MainLayout";
import { i18n, Translations } from "@i18n";

export const DownloadAppRoute = () => {
  const props: MainLayoutProps = {
    pageHeader: i18n.t(Translations.DownloadAppRouteHeader),
  };

  return (
    <MainLayout {...props}>
      <DownloadAppPlaceholder />
    </MainLayout>
  );
};
